// app/javascript/projects/components/ProjectsDisplay.jsx

import React, { useState, useCallback, useContext } from 'react';
import ColorConstants from 'constants/ColorConstants'
import { DropdownButton, MenuItem } from 'ui'
import EditIcon from '@mui/icons-material/Edit'
import GlyphBorder from './GlyphBorder'
import CodeNester from './CodeSelector/CodeNester'
import ProjectContext from 'contexts/ProjectContext';
import ColorSelector from './ColorSelector/ColorSelector'

const BORDER_RADIUS = "5px"

function GlyphDropdown(props) {
  const [show, setShow] = useState(false);
  const [colorMenuOpen, setColorMenuOpen] = useState(false);
  const [codeNesterOpen, setCodeNesterOpenState] = useState(false);

  const setCodeNesterOpen = useCallback((open) => {
    setCodeNesterOpenState(open);
  }, []);

  const projectContext = useContext(ProjectContext);
  const projectId = projectContext?.project?.id
  // Keep the pencil up while the color menu (anchored to this card) is open,
  // since the edit menu has already closed by then and hover may have ended.
  const isVisible = props.show || show || colorMenuOpen

  return (
    <GlyphBorder show={isVisible} backgroundFill={show} large>
      <div style={{width:"100%", height:"100%"}}>
        <DropdownButton
          variant="link"
          title={<EditIcon data-testid="EditIcon" style={{display:"block", color:ColorConstants.LIGHT_GREY, fontSize: 18}}/>}
          id={`edit-code-${props.codeId}`}
          style={{
            width: "100%",
            height: "100%",
            padding: 0,
            margin: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          // Mirror the menu's open state, not trigger focus: Base UI focuses
          // the popup on open and (with finalFocus={false}) leaves the
          // trigger unfocused on close, so a trigger onBlur never fires and
          // the pencil would stay visible forever after the menu is used.
          onToggle={setShow}
          noCaret
          pullRight
          // Rename and Move Under hand focus to their own input; the menu's
          // default return-to-trigger focus races it and blurs the rename
          // input the frame after it mounts, which commits and closes it.
          // Escape-close still restores the trigger (see ui/DropdownButton).
          finalFocus={false}
        >
          <MenuItem eventKey="1" onClick={props.seeDetails}>See Details</MenuItem>
          <MenuItem eventKey="4" onClick={() => setColorMenuOpen(true)} id={`change-color-${props.codeId}`}>Change Color</MenuItem>
          <MenuItem eventKey="2" onClick={props.onRename}>Rename</MenuItem>
          <MenuItem eventKey="3" onClick={() => setCodeNesterOpen(!codeNesterOpen)}>Move Under</MenuItem>
          <MenuItem divider />
          <MenuItem className='delete-code' eventKey="5" onClick={props.deleteCode}>Delete</MenuItem>
        </DropdownButton>
        {/* Rendered beside the menu, not inside it: Base UI unmounts the
            popup when an item is chosen, which would take the color menu
            down with it before it could open. Same pattern as CodeNester. */}
        <ColorSelector
          codeId={props.codeId}
          open={colorMenuOpen}
          onClose={() => setColorMenuOpen(false)}
        />
        <CodeNester 
          anchorRef={props.codeNesterAnchorRef} 
          open={codeNesterOpen} 
          setOpen={setCodeNesterOpen} 
          projectId={projectId} 
          codeId={props.codeId}
          codeName={props.codeName}
          maxDepth={props.maxDepth}
        />
      </div>
    </GlyphBorder>
  );
}

export default GlyphDropdown;
